import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SalesPipeline, SalesPipelineCreate, SalesPipelineFilter } from '../data/salesPipeline';

export function createSalesPipelineService(client: AxiosInstance) {
  return createCrudService<SalesPipeline, SalesPipelineCreate, SalesPipelineFilter>(
    client,
    '/crm/SalesPipeline',
    'id',
  );
}

export type SalesPipelineService = CrudService<SalesPipeline, SalesPipelineCreate, SalesPipelineFilter>;
